(function () {
	function customization(customAttributeElement) {
		var custs, forms = {}, custWrap, buyForm, priceCache = {}, napkinPrice = 0, napkinBase = 0;

		function init(customAttributeElement) {
			custWrap = customAttributeElement.querySelector('.gcusts');
			if (!custWrap) {
				return;
			}
			initFromWrap();
		}

		function initFromWrap() {
			custs = custWrap.querySelectorAll('.gcusts__cust');
			custs.forEach(function (cust) {
				var name = cust.id.replace('fieldset-', '');
				cust.dataset['custname'] = name;
				forms[name] = cust;
			});

			buyForm = findParentForm(custWrap);
			if (!buyForm) {
				return;
			}

			initDepends();
			initPriceChanges();
			initOccasionOther();
			initSubmit();
		}

		function findPriceElement() {
			return buyForm.querySelector('.buyBox .priceDetail .priceValue .price .n');
		}

		function initOccasionOther() {
			var elmOccation = custWrap.querySelector('#elm_occasion');
			var optText = custWrap.querySelector('#customization-CandleInscription-occasion_other');
			if (!elmOccation || !optText) {
				return;
			}

			var optOther = elmOccation.querySelector('#customization-CandleInscription-occasion-other');
			if (!optOther) {
				return;
			}

			var optLabel = optOther.closest('label');
			if (!optLabel) {
				return;
			}

			optLabel.appendChild(optText);
			optText.classList.remove('hide');
		}

		function initPriceChanges() {
			// Add to the whole of the buyForm, so all elements trigger this change
			buyForm.addEventListener('change', onPriceChange);
			custWrap.querySelectorAll('input[data-prices]').forEach(function (input) {
				var prices = JSON.parse(input.dataset.prices);
				var value = input.value;
				var custPrice = 0, syncQty = 'ONE';
				if (prices[value]) {
					custPrice = prices[value].price;
					syncQty = prices[value]['sync_qty'];
				}
				input.setAttribute('data-cust_price', custPrice);
				input.setAttribute('data-cust_sync_qty', syncQty);
			});

			var custWrapParent = custWrap.closest('.customAttribute');
			if (custWrapParent && custWrapParent.classList.contains('napkinInscription')) {
				initNapkinInscriptionPrices();
			}
		}

		function formatPriceValue(value) {
			return ('' + value).replace(/\B(?=(\d{3})+\b)/g, '.');
		}

		function findInitPrice() {
			var currentVariantId = parseInt(buyForm.variant.value);
			if (!currentVariantId) {
				return false;
			}
			var cacheKey = 'x' + currentVariantId;

			if (priceCache[cacheKey]) {
				return priceCache[cacheKey];
			}
			var variantData = findVariantData(currentVariantId);
			var ret;
			if (variantData) {
				var priceHtml = variantData.price;
				// basically find the .n element and grab the content
				ret = parseInt(priceHtml.replace(/.*\bn\b[^>]*>([0-9.,]+)<.*/, '$1').replace(/[,.]/, ''));
				priceCache[cacheKey] = ret;
				return ret;
			}
			else {
				var priceElement = findPriceElement();
				if (!priceElement) {
					return false;
				}
				ret = parseInt(priceElement.textContent.replace(/\D/ ,''));
				priceCache[cacheKey] = ret;
				return ret;
			}
		}

		function findVariantData(variantId) {
			for (var index in store.variants) {
				if (store.variants.hasOwnProperty(index)) {
					if (parseInt(store.variants[index].id) === variantId) {
						return store.variants[index];
					}
				}
			}
			return null;
		}

		function isPriceRelatedElement(element) {
			return element.id === 'qty' || element.dataset['cust_price']|| element.id.match(/^attribute_/);
		}

		function onPriceChange(event) {
			if (!isPriceRelatedElement(event.target)) {
				return;
			}

			var question = custWrap.querySelector('#elm_question input:checked');
			if(question.value === 'no') {
				custWrap.querySelectorAll('fieldset .elm_Variant:not(.delivery_selection) input[data-cust_price]:checked').forEach(function (el) {
					el.checked = false;
				});
			}

			var extraPrice = 0;
			var priceElement = findPriceElement();
			var selectedQty = parseInt(buyForm.qty.value);
			var initPrice = findInitPrice();
			if (!priceElement || !initPrice) {
				return;
			}
			custWrap.querySelectorAll('input[data-cust_price]:checked').forEach(function (el) {
				var custPrice = parseInt(el.dataset.cust_price);
				var custPriceTotal = custPrice;
				var syncQty = (el.dataset.cust_sync_qty);
				if (syncQty === 'SYNC') {
					custPriceTotal = custPrice * selectedQty;
				}
				extraPrice += custPriceTotal;
			});
			var napkinExtraPrice = 0;
			if (napkinPrice > 0) {
				var selectedQuestion = buyForm.querySelector('input[name="customization[question]"]:checked');
				if (selectedQuestion && selectedQuestion.value !== 'no') {
					napkinExtraPrice = findNapkinPrice(selectedQty);
				}
			}
			var total = (initPrice * selectedQty) + extraPrice + napkinExtraPrice;
			priceElement.textContent = formatPriceValue(total);
		}

		function findNapkinPrice(qty) {
			var numExtraPacks = qty - napkinBase;
			if (numExtraPacks < 1) {
				return 0;
			}
			return napkinPrice * numExtraPacks;
		}

		function initNapkinInscriptionPrices() {
			napkinBase = parseInt(custWrap.dataset['napkin_base']);
			napkinPrice = parseInt(custWrap.dataset['napkin_price']);
		}

		function initSubmit() {
			var form = findParentForm(custWrap);
			if (!form) {
				return;
			}

			form.addEventListener('submit', onSubmit);
		}

		function onSubmit(event) {
			event.preventDefault();
			// TODO
			return true;
		}

		function findParentForm(element) {
			if (element.nodeName === 'FORM') {
				return element;
			}
			if (element.nodeName === 'DOCUMENT') {
				return null;
			}
			return findParentForm(element.parentNode);
		}

		function initDepends() {
			custWrap.querySelectorAll('fieldset.depending').forEach(function (fieldset) {
				stefna_depends(fieldset, 'open');
			});
		}

		init(customAttributeElement);
	}

	function init() {
		document.querySelectorAll('.customAttribute').forEach(function (element) {
			customization(element);
		});
	}

	init();
})();
